import React from 'react';
import PropTypes from 'prop-types';
// Locales
import translate from 'locales/i18n';
//Mui components
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
// Theme
import theme from 'assets/theme/theme';

const AccountImportRules = ({ itemRules, attributeRules, setItemRules, setAttributeRules }) => {

    const handleUpdateItemRule = (rule, value) => {
        const newRules = itemRules.slice();
        setItemRules(newRules.map(r => {
            if (r.name === rule) {
                r.value = value;
            }
            return r;
        }));
    };

    const handleUpdateAttributeRule = (rule, attribute, value) => {

        const newRules = attributeRules.slice();
        setAttributeRules(newRules.map(r => {
            if (r.name === rule) {
                r.attributes = r.attributes.map(a => {
                    if (a.name === attribute) {
                        a.value = value;
                    }
                    return a;
                });
            }
            return r;
        }));
    };

    return (
        <div style={{ height: '80%', overflow: 'auto' }}>
            <TableContainer component={Paper}>
                <Table>
                    <TableBody>
                        <TableRow style={{ backgroundColor: theme.palette.grey.light }}>
                            <TableCell component='th' scope='row'>
                                Les règles liées aux articles
                            </TableCell>
                            <TableCell align='right'></TableCell>
                        </TableRow>
                        {itemRules.map(r =>
                            <TableRow key={r.name}>
                                <TableCell component='th' scope='row'>
                                    {translate.i18n(r.name.toUpperCase())}
                                </TableCell>
                                <TableCell align='right'>
                                    <FormControl style={{ width: 'auto' }}>
                                        <Select
                                            value={r.value}
                                            onChange={event => handleUpdateItemRule(r.name, event.target.value)}>
                                            {r.values.map(v => <MenuItem key={v} value={v}>{v}</MenuItem>)}
                                        </Select>
                                    </FormControl></TableCell>
                            </TableRow>)}
                        <TableRow style={{ backgroundColor: theme.palette.grey.light }}>
                            <TableCell component='th' scope='row'>
                                Les règles liées aux champs
                            </TableCell>
                            <TableCell align='right'></TableCell>
                        </TableRow>
                        {attributeRules.map(r => [
                            <TableRow key={r.name} style={{ backgroundColor: theme.palette.grey.ultralight }}>
                                <TableCell component='th' scope='row'>
                                    {translate.i18n(r.name.toUpperCase())}
                                </TableCell>
                                <TableCell align='right'></TableCell>
                            </TableRow>
                        ].concat(r.attributes.map(a =>
                            <TableRow key={a.name}>
                                <TableCell component='th' scope='row'>
                                    {`${a.name} (${a.header ? a.header : 'Aucun header associé'})`}
                                </TableCell>
                                <TableCell align='right'>
                                    <FormControl style={{ width: 'auto' }}>
                                        <Select
                                            value={a.value}
                                            onChange={event => handleUpdateAttributeRule(r.name, a.name, event.target.value)}>
                                            {r.values.map(v => <MenuItem key={v} value={v}>{v}</MenuItem>)}
                                        </Select>
                                    </FormControl></TableCell>
                            </TableRow>))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

AccountImportRules.propTypes = {
    attributeRules: PropTypes.array,
    itemRules: PropTypes.array,
    setAttributeRules: PropTypes.func,
    setItemRules: PropTypes.func
};

export default AccountImportRules;
